module.exports = __webpack_public_path__ + "static/media/restart_service_or_app.80fc1aea.svg";